import { ILanguage } from "../types";

export const tr: ILanguage = {
  translation: {
    root: {
      customize: "Özelleştir",
      businessAccount: "İşletme hesabı",
      verificationStatus: "Doğrulama Durumu",
      companyInformation: "Şirket bilgileri",
      businessName: "İşletme adı*",
      enterBusinessName: "İşletme Adı Girin",
      registrationNumber: "Şirket Kayıt Numarası",
      registrationNumberPlaceholder: "Kayıt Numarasını Girin",
      taxVat: "Vergi/KDV Kayıt Numarası",
      vatPlaceholder: "Vergi/KDV kayıt numarasını girin",
      registeredAddress: "Kayıtlı Adres*",
      tradingAddress: "Ticaret Adresi*",
      sameAsRegisteredAddress: "Kayıtlı adresle aynı",
      billingInformation: "Fatura bilgileri",
      billingPhoneNo: "Fatura Telefonu No.*",
      phonePlaceholder: "Telefon Numarasını Girin",
      billingEmail: "Fatura E-posta Adresi*",
      emailPlaceholder: "Faturalandırma e -postasını girin",
      driverDetails: "Sürücü Detayları",
      customerVerificationStatus: "Müşteri Doğrulama Durumu:",
      enterNationalInsuranceNumber: "Ulusal Sigorta Numarasını Girin",
      enterYourProfession: "Mesleğinizi Girin",
      enterDriving: "Sürüş Bilgilerini Girin",
      profileImage: "Profil Resmi",
      middleName: "İkinci ad",
      middleNameLabel: "İkinci ad",
      enterMiddleName: "İkinci adı girin",
      mode: "Mod",
      comments: "Yorumlar",
      number: "Sayı",
      image: "Görsel",
      uploadBack: "Arka Yüzü Yükle",
      uploadFront: "Ön Yüzü Yükle",
      issuedBy: "Veren kuruluş",
      document: "Belge",
      selectDocument: "Belge Seçin",
      addFile: "Dosya Ekle",
      noDataFound: "Veri bulunamadı",
      noDocumentsFound: "Belge bulunamadı",
      documentUpdatedAt: "Belge güncellendi",
      selectExpiryDate: "Son kullanma tarihini seçin",
      selectExpiryDateUpload:
        "Lütfen yüklemeden önce bir son kullanma tarihi seçin.",
      editExpiryDate: "Son kullanma tarihini düzenle",
      status: "Durum",
      images: "Görüntüler",
      note: "Not:",
      profession: "Meslek",
      nationality: "Uyruk",
      driving: "Sürüş",
      listOfDocumentsUploaded: "Yüklenen belgelerin listesi",
      listOfRequiredDocumentsUploaded: "Yüklenen gerekli belgelerin listesi",
      documentType: "Belge türü",
      documentName: "Belge adı",
      expiryDate: "Son kullanma tarihi",
      confirmDelete: "Silmeyi Onaylayın",
      actions: "İşlemler",
      completed: "Tamamlanmış",
      pending: "Beklemede",
      documentDeleteConfirmMsg:
        "Bu belgeyi silmek istediğinizden emin misiniz?",
      address: "Adres",
      useRegisteredAddress: "Kayıtlı adresi kullanın",
      billingEmailAddress: "Faturalandırma e -posta adresi*",
      billingEmailLabel: "Faturalandırma e -posta adresi",
      accountNumber: "Hesap numarası",
      firstName: "Ad*",
      firstNameLabel: "Ad",
      lastName: "Soyad*",
      lastNameLabel: "Soyad",
      contactEmail: "İletişim E -posta Adresi*",
      emailLabel: "E -posta adresi",
      contactPhone: "İletişim Telefon No.*",
      registeredAddressCaps: "Kayıtlı Adres",
      tradingAddressCaps: "Ticaret adresi",
      billingInformationCaps: "FATURA BİLGİLERİ",
      customerContactCaps: "Müşteri İletişimi",
      contactEmailInvalid: "Lütfen geçerli bir iletişim e -postası girin.",
      typeAddress: "Adres Türü",
      taxFees: "Vergiler ve Ücretler",
      vatTax: "KDV/Vergi",
      registrationNum: "Kayıt numarası",
      drivingLicenceNumber: "Ehliyet numarası",
      invalidPhoneNumber: "Geçersiz telefon numarası",
      onStartEmail: "Nasıl başlayacağınız konusunda size e -posta gönderdik.",
      emailNotSeen:
        'E -postayı birkaç dakika içinde görmüyorsanız, "önemsiz postanızı" veya "spam klasörünüzü" kontrol edin.',
      registerNow: "Şimdi kayıt ol",
      email: "E-posta",
      thankYou: "Teşekkürler",
      pickUpLocation: "Teslim Alma Noktası ",
      returnLocation: "İade Noktası *",
      pickUpDate: "Teslim Alma Tarihi *",
      pickUpTime: "Teslim Alma Saati *",
      invalidPickupLeadTime: "Seçilen teslim alma tarihi/saati izin verilen rezervasyon penceresinin dışında",
      dropOffDate: "İade Tarihi *",
      searchVehicles: "Araçları Ara",
      chooseLocation: "Bir konum veya posta kodu girin",
      vehicleGallery: "Araç Galerisi",
      privacyPolicy: "Gizlilik Politikası",
      termsAndConditions: "Şartlar ve Koşullar",
      dropOffTime: "İade Saati*",
      noVehiclesFound: "Seçilen kriterlere uyan araç bulunamadı",
      noRecordFound: "Üzgünüz, eşleşen herhangi bir kayıt bulunamadı!",
      vehicles: "Araçlar",
      endDate: "Bitiş Tarihi",
      startDate: "Başlangıç Tarihi",
      past: "Geçmiş",
      search: "Ara",
      upcoming: "Yaklaşan",
      current: "Mevcut",
      all: "Tümü",
      more: "Daha Fazla",
      toBeAssigned: "Atanacak",
      ref: "Referans No",
      reservation: "Rezervasyon",
      booking: "Rezervasyon",
      pricingSummary: "Fiyat Özeti",
      bookingSummary: "Rezervasyon Özeti",
      subscriptionVehicle: "Abonelik Aracı",
      insurance: "Sigorta",
      addons: "Eklentiler",
      protectionPlan: "Koruma Planı",
      initialRental: "İlk Kiralama",
      enrollmentFee: "Kayıt Ücreti",
      quantity: "Miktar",
      subscriptionPrice: "Abonelik Ücreti",
      weekly: "Haftalık",
      monthly: "Aylık",
      on: "için / üzerinden",
      numberOfDoors: "Kapı Sayısı",
      numberOfSeats: "Koltuk Sayısı",
      transmission: "Şanzıman",
      fuelType: "Yakıt Türü",
      week: "Hafta",
      day: "Gün",
      hour: "Saat",
      month: "Ay",
      gropu1Icon: "Grup 1 Simgesi",
      vatInclusive: "KDV Dahil",
      vat: "KDV",
      rental: "Kiralama",
      speedometer: "Kilometre Göstergesi",
      available: "Mevcut",
      priceLowToHigh: "Fiyata göre artan",
      priceHighToLow: "Fiyata göre azalan",
      weHaveSmartCars: "Akıllı Araçlarımız Mevcut",
      keylessSupport: "Akıllı araçlarımız anahtarsız erişimi destekler",
      keylessVehicles: "Anahtarsız Araçlar",
      duration: "Süre",
      swapsAllowed: "Araç Değişim Hakkı",
      enrollmentAmount: "Kayıt Tutarı",
      subscriptionAmount: "Abonelik Tutarı",
      mileageLimit: "Kilometre Sınırı",
      unlimited: "Sınırsız",
      weeks: "Haftalar",
      months: "Aylar",
      pricePerExtraMile: "Fazla Kilometre Ücreti",
      insurancePolicy: "Sigorta Poliçesi",
      removeSubscription: "Aboneliği Kaldır",
      noGroupFound: "Bu kriterlerle eşleşen grup bulunamadı!",
      vehicleTypeIcon: "Araç Tipi İkonu",
      min: "Min",
      selected: "Seçili",
      vehiclesSelected: "Seçilen Araçlar",
      selectVehicles: "Araçları Seç",
      personalDetails: "Kişisel Bilgiler",
      selectAddons: "Eklentileri Seç",
      continue: "Devam Et",
      locationSurcharge: "Lokasyon Ek Ücreti",
      onTotalRentalAmount: "toplam kiralama tutarı üzerinden",
      oneWayFee: "Tek Yön Ücreti",
      oneWayRentalCharge: "Tek Yön Kiralama Ücreti",
      total: "Toplam",
      firstMonthTotal: "İlk Ay Toplamı",
      firstWeekTotal: "İlk Hafta Toplamı",
      depositPayable: "Teslimatta Ödenecek Depozito",
      deposit: "Depozito",
      insuranceCaps: "SİGORTA",
      customAddon: "Özel Eklenti",
      chooseAPolicy: "Bir Poliçe Seçin",
      rate: "Oran",
      typeOfValet: "Vale Türü",
      nonNegotiable: "Değiştirilemez",
      selectValet: "Vale Seçin",
      collectionAddress: "Teslim Alma Adresi",
      remove: "Kaldır",
      deliveryAddress: "Teslimat Adresi",
      additionalInformation: "Ek Bilgi",
      confirmBooking: "Rezervasyonu Onayla",
      proceed: "Devam Et",
      getQuote: "Teklif Al",
      for: "için",
      agreeWithTermsAndConditions: "Şartlar ve Koşulları kabul ediyorum",
      selectCostCenter: "Maliyet Merkezi Seç",
      action: "İşlem",
      name: "Ad",
      enterDrivingLicenceNumber: "Sürücü Belgesi Numarasını Girin",
      enterLastName: "Soyadınızı Girin",
      enterFirstName: "Adınızı Girin",
      enterYourMail: "E-posta Adresinizi Girin",
      emailAsterisk: "E-posta*",
      quoteGeneratedCaps: "TEKLİF OLUŞTURULDU",
      updated: "Güncellendi",
      rentalCharges: "Kiralama Ücretleri",
      totalPayableAmount: "Toplam Ödenecek Tutar",
      payMinimumAmount: "Minimum Tutarı Öde",
      dueAmountPaidWhilePickup: "Teslim alırken ödenecek tutar",
      payOnCollection: "Teslimde Öde",
      CardAuthorization: "Kart şimdi provizyonlanacak, ödeme şu zamanda alınacaktır:",
      starts: "Başlıyor",
      confirm: "Onayla",
      payAtTimeOfPickup: "Şimdi ödeme yapma, teslimde öde",
      payFullAmountNow: "Tam Tutarı Şimdi Öde",
      payFullAmountRightAway: "Hemen Tam Tutarı Öde",
      FutureChargesRelatedToOngoingBooking:
        "Devam eden rezervasyonla ilgili gelecekteki ücretler bu ödeme yöntemiyle alınacaktır",
      saveThisCardForFutureInvoices:
        "Gelecekteki faturalar için bu kartı kaydet {{bookingSyntax}}",
      payLater: "Daha Sonra Öde",
      creditLimitAssigned:
        "Bu şirkete atanan kredi limiti ödeme için kullanılacaktır",
      CreditsAgainstBooking: "Rezervasyon karşılığında krediler uygulanacaktır",
      useCreditNoteBalance: "Kredi Notu Bakiyesini Kullan",
      telNo: "Tel No",
      vatNo: "KDV No",
      customer: "Müşteri",
      emailAddress: "E-posta Adresi",
      phoneNumber: "Telefon Numarası",
      dateCreated: "Oluşturulma Tarihi",
      poNumber: "Sipariş No",
      dateTime: "Tarih/Saat",
      dropOffLocation: "Araç İade Lokasyonu",
      contractHire: "Sözleşmeli Kiralama",
      subscription: "Abonelik",
      charges: "Ücretler",
      enrollmentFees: "Kayıt Ücretleri",
      na: "Uygun Değil / Yok",
      grandTotal: "Genel Toplam",
      rentalPrice: "Kiralama Fiyatı",
      daysProRated: "Kıst Günler",
      locationSurcharges: "Lokasyon Ek Ücretleri",
      ofTotalRentalAmount: "toplam kiralama tutarının",
      nextBilling: "Sonraki Fatura",
      subTotal: "Ara Toplam",
      discount: "İndirim",
      discountedPrice: "İndirimli Fiyat",
      description: "Açıklama",
      descriptionLabel: "Açıklama",
      thisIsA: "Bu bir",
      exemptedBooking: "muaf rezervasyon",
      thisIstestCourtsey: "Bu bir test / iyi niyet rezervasyonudur",
      isCalculatedAgainst: "üzerinden hesaplanır",
      priceAndSelectedAddons:
        "sigorta ve depozito hariç fiyat ve seçilen eklentiler",
      recurringWeeklyMonthlyInvoice:
        "Haftalık/aylık tekrar eden fatura bir sonraki dönem için otomatik olarak oluşturulacaktır.",
      additionalNote: "Ek Not",
      payableAtVehicleCollection: "Araç tesliminde ödenecek tutar",
      purchaseOrderUpdated:
        "Satın alma siparişi numarası başarıyla güncellendi",
      proceedToPay: "Ödemeye Geç",
      searchResults: "Arama Sonuçları",
      subscriptions: "Abonelikler",
      contractHireVehicleWeeklyMonthly:
        "Haftalık/aylık sözleşmeli araç kiralama",
      subscribeVehicleWeeklyMonthly: "Haftalık/aylık araç aboneliği",
      contractNow: "Sözleşmeyi Başlat",
      subscribeNow: "Şimdi Abone Ol",
      backToBookingCategorySelection:
        "Rezervasyon kategorisi seçimine geri dön.",
      accountVerification: "Hesap Doğrulama",
      profileNotVerifiedMessage:
        "Profiliniz doğrulanmadı. Devam etmek için lütfen operatörünüzle iletişime geçin ve hesabınızı doğrulatın.",
      update: "Güncelle",
      reference: "Referans",
      companyRegistrationNumber: "Şirket Kayıt Numarası",
      availableFrom: "Şu tarihten itibaren mevcut",
      paellaDish: "Paella",
      vehicleCatalogues: "Araç Katalogları",
      vehicleDetails: "Araç Detayları",
      verification: "Doğrulama",
      protectionPlans: "Koruma Planları",
      authorisedSignatory: "Yetkili İmzalayan",
      item: "Kalem",
      price: "Fiyat",
      unitPrice: "Birim Fiyat",
      vehicleSpecification: "Araç Özellikleri",
      model: "Model",
      color: "Renk",
      bodyType: "Gövde Tipi",
      tankCapacity: "Depo Kapasitesi",
      interiorColor: "İç Renk",
      seats: "Koltuklar",
      doors: "Kapılar",
      whatsIncluded: "Neler dahil",
      timeVehicleSwap: "Araç Değişim Hakkı / Araç Değişim Sayısı",
      contractualDetails: "Sözleşme detayları",
      longerSubscribeSaveMore:
        "Ne kadar uzun süre abone olursanız, o kadar tasarruf edersiniz",
      tailorSubscriptionToNeeds:
        "Aboneliğinizi ihtiyaçlarınıza göre özelleştirin",
      easyManagementOnline: "Kolay ve çevrimiçi yönetim",
      SwapCarAndCancel: "İstediğinizde araç değiştirin veya iptal edin",
      customizeYourContract: "Sözleşmenizi özelleştirin",
      selectPlan: "Plan Seçin",
      selectTenure: "Süre Seçin",
      tentativeStartDate: "Tahmini başlangıç tarihi",
      selectDate: "Tarih Seçin",
      selectTime: "Saat Seçin",
      contractSummary: "Sözleşme Özeti",
      subscriptionChargesLabel: "Abonelik Ücretleri",
      initialRentalPayment: "İlk Kira Ödemesi",
      continueToPersonalDetails: "Kişisel Bilgilere Devam Et",
      noAvailableAddonsFound:
        "Arama kriterlerinize uygun kullanılabilir eklenti bulunamadı",
      nationalInsuranceNumber: "Ulusal Sigorta Numarası",
      updateQuote: "Teklifi Güncelle",
      driverNotAvailable:
        "Sürücü mevcut değil, lütfen kiralama operatörünüzle iletişime geçin",
      selectDeliverySlot: "Teslimat Zaman Aralığı Seçin",
      wantDelivered: "Teslim edilmesini ister misiniz?",
      verifyYourLicenceCaps: "SÜRÜCÜ BELGENİZİ DOĞRULAYIN",
      validateAllFieldsForLicenceCheck:
        "Lütfen aşağıdaki bilgileri girin veya doğrulayın. Tüm alanlar zorunludur.",
      postCode: "Posta Kodu",
      thisAgreementAllows: "Bu anlaşma şunlara izin verir:",
      leftoverAgreement:
        "sigorta ortağımızın sürücü belgenizi kontrol etmesine ve verdiğiniz verileri sigortacılar ve diğer ilgili taraflarla (Coastr) paylaşmasına. Yukarıdaki şartları kabul ediyor musunuz?",
      verifyLicence: "Ehliyeti Doğrula",
      licenceCheckingInProgress: "Ehliyet kontrolü devam ediyor",
      checkingInProgress:
        "Bu işlem 2 dakika kadar sürebilir, lütfen bekleyin ve tarayıcınızı kapatmayın",
      licenceCheckingFailed: "Ehliyet kontrolü başarısız oldu",
      checkForCorrectDetails:
        "Girdiğiniz bilgilerin doğru olduğundan emin olun.",
      tryAgainLater: "Sorun devam ederse lütfen daha sonra tekrar deneyin.",
      licenceCheckedSuccessfully: "Ehliyet başarıyla kontrol edildi",
      licenceSummaryAdded: "Ehliyet özeti müşteri kaydına eklendi",
      creditScore: "Kredi Puanı",
      lastChecked: "Son Kontrol",
      recheckCreditScore: "KREDİ SKORUNU YENİDEN KONTROL ET",
      checkCreditScore: "KREDİ SKORUNU KONTROL ET",
      proceedToPayment: "Ödemeye Geç",
      paymentOverview: "Ödeme Özeti",
      schedule: "Ödeme Planı / Takvim",
      contractDetails: "Sözleşme Detayları",
      plan: "Plan",
      swaps: "Değişimler",
      payableDeposit: "Ödenecek Depozito",
      customerVerification: "Müşteri Doğrulaması",
      provideAdditionalDetails:
        "Rezervasyon oluşturmak için lütfen hesap bölümünde aşağıdaki ek bilgileri sağlayın",
      profilePhoto: "Profil Fotoğrafı",
      submitYourRequest:
        "İşlemi tamamladıktan sonra, aşağıdaki gönder butonuna tıklayarak onay için isteğinizi gönderin",
      submit: "Gönder",
      uploadLicenceImages: "Ehliyet Görsellerini Yükle",
      add: "Ekle",
      uploadFrontBackLicence:
        "Ehliyetin ön ve arka yüzünü yükleyin. Desteklenen dosya formatları: .png, .jpeg, .jpg!",
      uploadLicenceImage: "Ehliyet Görseli Yükle",
      authority: "Veren Kurum",
      drivingLicenceExpiryDate: "Ehliyet Son Kullanma Tarihi",
      licenceNumber: "Ehliyet Numarası",
      preview: "Önizleme",
      addOn: "Eklenti",
      contact: "İletişim",

      selectSlot: "Zaman Dilimi Seç",
      deliveryType: "Teslimat Türü",
      experience: "Deneyim",
      type: "Tür",
      bookATestDrive: "Test Sürüşü Rezervasyonu Yap",
      selectASlot: "Bir Zaman Dilimi Seçin",
      selectDateTimeSlot: "Tarih ve Saat Seçin",
      vehicleNotAvailable: "Seçilen tarihte araç mevcut değil",
      selectDifferentDate: "Lütfen farklı bir tarih seçin",
      selectCar: "Bir Araç Seçin",
      availableNow: "Şimdi Mevcut",
      new: "Yeni",
      phone: "Telefon",
      customerDetails: "Müşteri Bilgileri",
      dealershipAddress: "Bayi Adresi",
      dealership: "Bayi",
      bookingTime: "Rezervasyon Zamanı",
      bookingType: "Rezervasyon Türü",
      details: "Detaylar",
      your: "Senin",
      confirmation: "Onay",
      selectDealership: "Bayi Seçin",
      testDriveRequested: "Test Sürüşü Talep Edildi",
      testDrive: "Test Sürüşü",
      mobileNumber: "Cep Telefonu Numarası",
      drivingLicenseNumber: "Ehliyet Numarası",
      enterLicenseNumber: "Ehliyet Numaranızı Girin",
      requestTestDrive: "Test Sürüşü Talep Et",
      slot: "Zaman Dilimi",
      vehicle: "Araç",
      selectSubsctiption: "ABONELİK SEÇ",
      pricesShownOnSelectedDuration:
        "Gösterilen fiyatlar seçilen süreye göre belirlenmiştir",
      priceComparison: "Fiyat Karşılaştırması",
      oneTime: "Tek Seferlik",
      subscriptionStartsAt: "Abonelik şu fiyattan başlar",
      paymentProcessing: "Ödeme İşleniyor",
      pleaseWait: "Lütfen bekleyin",
      paymentComplete: "Ödeme Tamamlandı",
      paymentInProgress: "Ödeme devam ediyor",
      atleastUploadOne: "En az bir dosya yükleyin",
      upload: "Yükle",
      uploadServiceNotAvailable: "Yükleme hizmeti kullanılamıyor. Lütfen tekrar deneyin.",
      uploading: "Yükleniyor...",
      atDealership: "Bayide",
      atHome: "Evde",

      enterYourEmailPassword:
        "Giriş yapmak için e-posta adresinizi ve şifrenizi girin",
      enterMailHere: "E-posta adresinizi buraya girin",
      required: "Gerekli",
      password: "Şifre",
      reset: "Sıfırla",
      otpForPasswordReset:
        "Şifrenizi sıfırlamak için e-posta adresinize bir OTP göndereceğiz",
      sendOtp: "OTP gönder",
      loginInstead: "Bunun yerine giriş yap",
      verifyOtp: "OTP'yi doğrula",
      otp: "OTP",
      otpSentToEmail: "OTP e-posta adresinize gönderildi",
      enterOtp: "OTP girin",
      enterOtpHere: "OTP'yi buraya girin",
      verify: "Doğrula",
      setNewPassword: "Yeni şifre belirle",
      eightCharLong: "8 karakter uzunluğunda olmalıdır",
      reenterPassword: "Şifreyi buraya tekrar girin",
      signInAs: "Şu şekilde giriş yap",
      as: "Olarak",
      selectAccountToProceed: "Devam etmek için bir hesap seçin",
      personalAccount: "Bireysel hesap",
      asBusinessCustomer: "Kurumsal müşteri olarak",
      asDriver: "Sürücü olarak",
      enterPassword: "Şifreyi buraya girin",
      registerAs: "Şu şekilde kaydol",
      individual: "Bireysel",
      business: "Kurumsal",
      operatorMandatedCustomerCheck:
        "Operatör, onaylı rezervasyon öncesinde müşteri kontrolü talep ediyor. Lütfen onay için bekleyin.",
      createAccount: "Hesap oluştur",
      emailedHowToGetStarted:
        "Başlamak için talimatları içeren bir e-posta gönderdik.",
      ifDontSeeEmail:
        "Birkaç dakika içinde e-posta gelmezse spam veya gereksiz klasörünüzü kontrol edin.",
      previousVehicleDetails: "Önceki Araç Bilgileri",
      registration: "Plaka / Tescil",
      makeModel: "Marka/Model",
      vin: "VIN numarası",
      driverAssigned: "Sürücü atandı",
      currentVehicleDetails: "Mevcut araç bilgileri",
      priceGroup: "Fiyat grubu",
      unlimitedMileage: "Sınırsız kilometre",
      paymentStatus: "Ödeme durumu",
      invoiceNumber: "Fatura numarası",
      deliveryDetails: "Teslimat detayları",
      collectionDetails: "Teslim Alma Detayları",
      coiDetails: "COI detayları",
      policyName: "Poliçe adı",
      planName: "Plan adı",
      policyNumber: "Poliçe numarası",
      provider: "Sağlayıcı",
      vehicleSwapDetails: "Araç değişim detayları",
      swapMyCar: "Aracımı değiştir",
      NoOfSwapsAllowed: "İzin Verilen Araç Değişim Sayısı",
      NoOfSwapsAvailed: "Kullanılan değişim sayısı",
      NoOfSwapsRemaining: "Kalan değişim sayısı",
      swapRequestHistory: "ARAÇ DEĞİŞİM TALEP GEÇMİŞİ",
      requestedOn: "TALEP EDİLDİ",
      swapDate: "DEĞİŞİM TARİHİ",
      oldVehicle: "Eski araç",
      newVehicle: "Yeni araç",
      addonsDetails: "Eklenti detayları",
      paymentDetails: "Ödeme detayları",
      billingPeriod: "Faturalama dönemi",
      creationDate: "Oluşturulma tarihi",
      invoiceType: "Fatura türü",
      regular: "Normal",
      depositDetails: "Depozito detayları",
      amount: "Tutar",
      totalPaidAmount: "Toplam ödenen tutar",
      cancellationCharges: "İptal ücretleri",
      totalRefundAmount: "Toplam iade miktarı",
      anUnpaid: "ödenmemiş rezervasyon",
      aPartiallyPaid: "kısmen ödenmiş rezervasyon",
      thisIs: "Bu bir",
      pleaseContactUs: "Daha fazla bilgi için lütfen bizimle iletişime geçin",
      reasonToCancelTheBooking: "Rezervasyonu iptal etmek için bir neden seçin",
      enterTheReason: "Nedeni girin",
      dismiss: "Reddet",
      selectVehicle: "Araç seçin",
      bookingConfirmationInProgress: "Rezervasyon onayı devam ediyor",
      pleaseProvideTheReason: "Lütfen nedeni belirtin",
      quote: "Teklif",
      management: "Yönetim",
      pickupDateTimePassed: "Teslim alma tarihi/saati geçmiş veya ücretsiz",
      profileRejectedOrPending: "Profiliniz reddedildi veya onay bekliyor",
      testDriveAgreement: "Test sürüşü anlaşması",
      rentalAgreement: "Kira sözleşmesi",
      contractHireAgreement: "Sözleşmeli kiralama sözleşmesi",
      subscriptionAgreement: "Abonelik Sözleşmesi",
      zeroChargeBooking:
        "Ücretsiz rezervasyonlar yalnızca operatör tarafından onaylanabilir",
      pickupDateTimeInPast: "Alım tarihi/zamanı geçmiş",
      creditNoteSummary: "Kredi notu özeti",
      customerName: "Müşteri adı",
      customerEmail: "Müşteri e-postası",
      creditNoteRef: "Kredi notu referansı",
      invoiceRef: "Fatura referansı",
      totalAmount: "Toplam tutar",
      amountAdjustedRefunded: "Ayarlanmış / iade edilen tutar",
      amountAvailable: "Mevcut tutar",
      adjustments: "Düzenlemeler",
      particulars: "Açıklama / Kalem Detayı",
      adjustedToInvoice: "Faturaya uygulandı",
      adjustedAt: "Düzenlenme Tarihi",
      creditNotes: "Kredi notları",
      availableBalance: "Mevcut bakiye",
      searchCreditNoteId: "Kredi notu ID'sini ara",
      active: "Aktif",
      exhausted: "Tükenmiş",
      creditNoteId: "Kredi notu ID'si",
      dateGenerated: "Oluşturulma tarihi",
      amountRefunded: "İade edilen tutar",
      amountRemaining: "Kalan miktar",
      dashboard: "Panel",
      activeVehiclesCount: "Aktif araç sayısı",
      totalActiveBookings: "Toplam aktif rezervasyon",
      totalVehicles: "Toplam araç",
      vehicleChecks: "Araç kontrolleri",
      inProgressBookings: "Devam eden rezervasyonlar",
      vehicleChecksCompleted: "Tamamlanan araç kontrolleri",
      vehicleChecksPending: "Bekleyen araç kontrolleri",
      dailyBalance: "Günlük bakiye",
      totalOutstanding: "Toplam açık bakiye",
      UnpaidInvoices: "Ödenmemiş fatura sayısı",
      regularInvoices: "Normal faturalar",
      sundryInvoices: "Çeşitli faturalar",
      addNewDriver: "Yeni sürücü ekle",
      phoneNo: "Telefon no",
      drivingLicenceImage: "Ehliyet resmi",
      licenceIssuedBy: "Ehliyet veren",
      licenceExpiryDate: "Ehliyet bitiş tarihi",
      drivingLicenceIssueDate: "Ehliyet Düzenleme Tarihi",
      dateOfBirth: "Doğum tarihi",
      taskDetailsNotFound: "Görev detayı bulunamadı.",
      pcoIssueDate: "Sürücü PCO Lisansı Veriliş Tarihi",
      bookingRef: "Rezervasyon ref.",
      rateYourExperience: "Deneyiminizi puanlayın",
      driverInformation: "Sürücü bilgisi",
      saveDrivers: "Sürücüleri kaydet",
      expiry: "Süre dolumu",
      areYouSureDriver: "Bu sürücüyü silmek istediğinizden emin misiniz?",
      drivers: "Sürücüler",
      noDriverFound: "Üzgünüz, sürücü bulunamadı!",
      invoices: "Faturalar",
      searchInvoiceId: "Fatura ID'si ara",
      unpaid: "Ödenmemiş",
      paid: "Ödenmiş",
      void: "İptal",
      invoiceId: "Fatura ID'si",
      invoiceDate: "Fatura tarihi",
      balanceDue: "Bakiye",
      dueDate: "Son ödeme tarihi",
      invoiceSummary: "Fatura özeti",
      invoice: "Fatura",
      sundry: "Çeşitli",
      addPayment: "Ödeme ekle",
      customerPhoneNumber: "Müşteri telefon numarası",
      invoiceReference: "Fatura referansı",
      period: "Dönem",
      invoiceVoidedBy: "Fatura iptal eden",
      invoicePeriod: "Fatura dönemi",
      invoiceStatus: "Fatura durumu",
      invoiceAmount: "Fatura tutarı",
      amountDue: "Ödenmesi gereken tutar",
      generatedAt: "Oluşturulma zamanı",
      vehicleRentalCharges: "Araç kiralama ücretleri",
      refundable: "İade edilebilir",
      date: "Tarih",
      thisIsTestCourtsey: "Bu bir test/iyi niyet",
      invoicesConsolidated: "Faturalar birleştirildi",
      payments: "Ödemeler",
      exempted: "Muaf tutulmuş",
      pleaseLoginFirst: "Lütfen önce giriş yapın",
      account: "Hesap",
      tracking: "Takip",
      uploadImages: "Resimleri yükle",
      updateVehicleState: "Araç durumunu güncelle",
      vehicleImage: "Araç resmi",
      fuelStatus: "Yakıt durumu",
      batteryStatus: "Akü durumu",
      odometerReading: "Kilometre sayacı",
      nextServiceDetails: "Bir sonraki servis detayları",
      serviceType: "Servis türü",
      serviceStatus: "Servis durumu",
      appointmentDate: "Randevu tarihi",
      estdCompletionDate: "Tahmini bitiş tarihi",
      serviceProviderName: "Servis sağlayıcı adı",
      serviceProviderAddress: "Servis sağlayıcı adresi",
      notesForDriver: "Sürücü notları",
      exteriorDamages: "Dış hasarlar",
      interiorDamages: "İç hasarlar",
      generalChecks: "Genel kontroller",
      accessoriesChecks: "Aksesuar kontrolleri",
      chooseFuelLevel: "Yakıt seviyesini seçin",
      lastReported: "Son bildirilen",
      circumstance: "Koşul",
      title: "Başlık",
      damageKind: "Hasar türü",
      damageArea: "Hasar alanı",
      referenceNumber: "Referans numarası",
      damageDetail: "Hasar detayı",
      addImage: "Resim ekle",
      addImages: "Resimler ekle",
      done: "Tamamlandı",
      searchExistingDriver: "Mevcut sürücüyü ara",
      success: "Başarılı",
      assignDriver: "Sürücü ata",
      plate: "Plaka",
      unassigned: "Atanmamış",
      assigned: "Atandı",
      make: "Marka",
      vehicleAppearOnceAssigned: "Araçlar atandıktan sonra görünecek!",
      searchVehicle: "Araç ara",
      trackingHistoryHrs: "Takip geçmişi (saat)",
      telemetryDevice: "Telemetri cihazı",
      lastLocation: "Son konum",
      latitude: "Enlem",
      longitude: "Boylam",
      forSelectedPeriod: "Seçilen dönem için –",
      milesDriven: "Sürüş mesafesi (mil)",
      engineHours: "Motor saatleri",
      fuelUsageLitres: "Yakıt tüketimi (litre)",
      stoppagehours: "Durma süresi (saat)",
      chargeStatus: "Şarj durumu",
      fuelUsage: "Yakıt kullanımı",
      batteryLevel: "Akü seviyesi",
      speedLimit: "Hız sınırı",
      invalidEmailAddress: "Geçersiz e-posta adresi",
      unableLoadCompanyDetails: "Şirket bilgileri yüklenemiyor",
      bookingConfirmationProgress: "Rezervasyon onayı devam ediyor...",
      doNotHitBack:
        "Lütfen geri, iptal veya tarayıcıyı kapatmayın. İşlem 2 dakikaya kadar sürebilir.",
      summary: "Özet",

      addNew: "Yeni Ekle",
      street: "Sokak",
      city: "Şehir",
      regionState: "Bölge/İl",
      country: "Ülke",
      zipPostalCode: "Posta Kodu",
      cardAuthorizeNowButAmountLater:
        "Kart şimdi yetkilendirilecek ancak tutar rezervasyon başladığında tahsil edilecek",
      saveThisCardForFutureInvoicesBooking:
        "Bu kartı, bu rezervasyon için gelecekteki faturaları ödemek üzere kaydet.",
      confirmBookingPayLater: "Rezervasyonu Onayla, Sonra Öde",
      confirmBookingAndPayAtPickup: "Şimdi Onayla ve Teslimatta Öde",
      bookingReferenceNumber: "Rezervasyon Referans Numarası",
      pickupDetails: "Teslim Alma Detayları",
      dropoffDetails: "Teslim Etme Detayları",
      to: "İle",
      bookingReference: "Rezervasyon Referansı",
      invoiceStartDate: "Fatura Başlangıç Tarihi:",
      invoiceEndDate: "Fatura Bitiş Tarihi:",
      availableAtLocations: "Mevcut Lokasyonlar",
      benefits: "Faydalar",
      passportNumber: "Pasaport Numarası",
      enterPassportNumber: "Pasaport numaranızı girin",
      vehicleSwapRequest: "Araç Değişim Talebi",
      checkVehicleAvailability: "Araç Mevcudiyetini Kontrol Et",
      pleaseSelectDateAndSearch:
        "Lütfen tarih seçin ve araç uygunluğunu kontrol etmek için ara düğmesine tıklayın",
      noVehicleFoundForSelectedDate: "Seçilen tarihte araç bulunamadı",
      notes: "Notlar",
      writeYourNoteHere: "Notunuzu buraya yazın",
      updateRequest: "Talebi Güncelle",
      generateRequest: "Talep Oluştur",
      cancelRequest: "Talebi İptal Et",
      operator: "Operatör",
      you: "Siz",
      maximum: "Maksimum",
      imagesAreAllowed: "resim yüklemenize izin verilir.",
      dragAndDropFile: "Bir dosya sürükleyin veya tıklayın",
      areAllowed: "izin verilir",
      cancelBooking: "Rezervasyonu İptal Et",
      booked: "Rezerve edildi",
      organisation: "Kuruluş",
      vatNumber: "KDV Numarası",
      sort: "Sırala",
      DELETE_DRIVER_DESCRIPTION: "Sürücüyü silmek istediğinizden emin misiniz?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Sürücüyü silmek istediğinizden emin misiniz?",
        "Delete Driver": "Sürücüyü Sil",
      },
      currentInvoiceStatus: {
        PAID: "ÖDENDİ",
        UNPAID: "ÖDENMEDİ",
        VOID: "GEÇERSİZ",
        "PARTIALLY PAID": "KISMEN ÖDENDİ",
        DRAFT: "TASLAK",
      },
      currentBookingStatus: {
        CANCELLED: "İPTAL EDİLDİ",
        COMPLETED: "TAMAMLANDI",
        "CONFIRMATION IN PROCESS": "ONAY İŞLEMDE",
        CONFIRMED: "ONAYLANDI",
        "IN PROGRESS": "DEVAM EDİYOR",
        QUOTE: "TEKLİF",
        DRAFT: "TASLAK",
        "REQUIRES APPROVAL": "ONAY GEREKİYOR",
        DECLINED: "REDDEDİLDİ"
      },
      minBookingDurationMessage:
        "Minimum rezervasyon süresi {{hours}} saattir. Lütfen teslim alma veya bırakma tarihini ve saatini buna göre ayarlayın.",
      maxBookingDurationMessage:
        "Maksimum rezervasyon süresi {{days}} gündür. Lütfen teslim alma veya bırakma tarihini ve saatini buna göre ayarlayın.",
      usevaletTypes: {
        Delivery: "Teslimat",
        Collection: "Teslim Alma",
        "Delivery and Collection": "Teslimat ve Teslim Alma",
      },
      selectCollectionSlot: "Teslim Alma Zamanı Seçin",
      driverUnavailableNote:
        "Not: Sürücü mevcut değil, lütfen kiralama operatörü ile iletişime geçin.",
      cancellationReasons: {
        "Requirement changed": "Gereksinim değişti",
        Price: "Fiyat",
        Other: "Diğer",
      },
      imagePreview: "Görüntü Önizleme",
      markDamage: "Hasarı İşaretle",
      vehicleDamageImages: "Araç Hasar Görselleri",
      incidentDate: "Olay Tarihi",
      incidentTime: "Olay Saati",
      clear: "Temizle",
      bookingStatus: "Rezervasyon Durumu",
      daysInBooking: "Rezervasyonda Günler",
      accumulatedDays: "Birikmiş günler",
      endingThisMonth: "Bu ay bitiyor",
      creditUtilisation: "Kredi kullanımı",
      creditLimit: "Kredi limiti",
      utilized: "Kullanılmış",
      totalDrivers: "Toplam Sürücüler",
      vehiclesAllocated: "Tahsis edilen araçlar",
      mileageOverview: "Kilometre Genel Bakış",
      mileageLimitExited: "Kilometre sınırı çıktı",
      approachingMileageLimits: "Kilometre sınırlarına yaklaşmak",
      motReminders: "MOT Hatırlatıcılar",
      totalMotTests: "Toplam MOT Testleri",
      healthCheckReminders: "Sağlık kontrolü hatırlatmaları",
      totalHealthCheckTests: "Toplam sağlık kontrol testleri",
      failed: "Başarısız",
      serviceReminders: "Servis Hatırlatmaları",
      overdue: "Gecikmiş",
      totalServiceReminders: "Toplam Servis Hatırlatması",
      createNewServiceRequest: "Yeni Servis Talebi Oluştur",
      serviceDetails: "Servis Detayları",
      selectedVehicle: "Seçilen Araç",
      serviceRequestSelectVehicle: "Araç Seçin",
      loadingVehicles: "Araçlar yükleniyor...",
      noActiveVehiclesFound: "Aktif araç bulunamadı",
      addDetails: "Detay Ekle",
      addItems: "Öğe Ekle",
      issueType: "Sorun Türü",
      issueTypePlaceholder: "örn., Kırık Kilit",
      descriptionPlaceholder: "örn., Ön sol kapı kilidi",
      uploaded: "Yüklendi",
      additionalComments: "Ek Yorumlar",
      additionalCommentsPlaceholder: "Ek bilgi ekleyin...",
      submitting: "Gönderiliyor...",
      submitRequest: "Talep Gönder",
      serviceRequestNote: "Talebiniz servis ekibimiz tarafından incelenecektir. Onaylandığında veya ek bilgi gerektiğinde bir bildirim alacaksınız.",
      serviceRequestDetails: "Servis Talebi Detayları",
      createdDate: "Oluşturulma Tarihi",
      estimatedCost: "Tahmini Maliyet",
      requestProgress: "Talep Durumu",
      issuesReported: "Bildirilen Sorunlar",
      issue: "Sorun",
      imageAlt: "Resim",
      serviceProvider: "Servis Sağlayıcı",
      appointment: "Randevu",
      at: "saat",
      estimatedCompletion: "Tahmini Tamamlanma",
      workToBeDone: "Yapılacak İş",
      cost: "Maliyet",
      totalCost: "Toplam Maliyet",
      requestDeclined: "Talep Reddedildi",
      communication: "İletişim",
      serviceTeam: "Servis Ekibi",
      noCommunicationYet: "Henüz iletişim yok",
      addMessage: "Mesaj Ekle",
      askQuestionPlaceholder: "Bir soru sorun veya ek bilgi sağlayın...",
      sending: "Gönderiliyor...",
      sendMessage: "Mesaj Gönder",
      additionalInformationRequested: "Ek Bilgi Talep Edildi",
      provideFollowingInformation: "Talebinizi işleme koymamıza yardımcı olmak için lütfen aşağıdaki bilgileri sağlayın:",
      yourAnswer: "Cevabınız:",
      typeAnswerHere: "Cevabınızı buraya yazın...",
      submitAnswers: "CEVAPLARI GÖNDER",
      approved: "Onaylandı",
      serviceRequests: "Servis Talepleri",
      scheduledServicesTitle: "Planlanan servisler",
      scheduledServicesBellAria: "Planlanan araç servislerini görüntüleyin",
      noScheduledServices: "Planlanmış servis yok",
      approveScheduledServiceSuccess: "Hizmet başarıyla onaylandı",
      requestChangesSuccess: "Değişiklik talebi onay için gönderildi",
      requestChanges: "Değişiklik Talep Et",
      modifyServiceRequest: "Hizmet talebini düzenle",
      modifyDetails: "Detayları düzenle",
      vehicleAndCategory: "Araç ve kategori",
      cannotModify: "Düzenlenemez",
      appointmentDetails: "Randevu detayları",
      time: "Saat",
      scheduledServiceReviewHint: "Lütfen planlanan servisi inceleyin. Detaylar doğruysa onaylayın veya değişiklik talep edin.",
      approveService: "Hizmeti onayla",
      jobSheet: "İş emri",
      declined: "Reddedildi",
      lastUpdated: "Son güncelleme",
      explainChangesPlaceholder: "Bu değişikliklere neden ihtiyacınız olduğunu açıklayın...",
      submitChanges: "Değişiklikleri Gönder",
      expenses: "Giderler",
      filters: "Filtreler",
      applyFilters: "Filtreleri Uygula",
      activeFilters: "Aktif Filtreler",
      newServiceRequest: "Yeni Hizmet Talebi",
      rowsPerPage: "Sayfa başına satır:",
      of: "/",
      moreThan: "daha fazla",
      searchServiceRequestsPlaceholder: "Referans numarası, araç veya duruma göre ara...",
      selectOption: "Bir seçenek seçin",
      selectMultiple: "Bir veya daha fazla seçenek seçin",
      uploadPhoto: "Fotoğraf Yükle",
      view: "Görüntüle",
      typeYourResponse: "Yanıtınızı yazın",
      pleaseSelectServiceType: "Lütfen bir hizmet türü seçin",
      pleaseSelectServiceCategory: "Lütfen bir hizmet kategorisi seçin",
      selectServiceType: "Hizmet Türünü Seç",
      serviceCategory: "Hizmet Kategorisi",
      selectServiceCategory: "Hizmet Kategorisini Seç",
      unableToDetermineServiceBranch: "Hizmet şubeniz belirlenemedi. Lütfen daha sonra tekrar deneyin.",
      accidentDamageInformation: "Kaza / Hasar Bilgileri",
      documentUploads: "Belge Yüklemeleri",
      adHoc: "Plansız / Tek Seferlik",
      emergency: "Acil",
      serviceQuestionnaire: "Servis Anketi",
      serviceQuestionnaireDescription: "Hizmet ekibimizin her şeyi önceden hazırlayabilmesi için birkaç ek detay sağlayın.",
      selectServiceCategoryPrompt: "Bu hizmet için gerekli soruları görmek üzere bir hizmet kategorisi seçin.",
      noServiceQuestionsForType: "Bu hizmet türü için ek soru yok. İstekle devam edebilirsiniz.",
      fileUploadGuidance: "Dosya başına 5 MB'a kadar JPEG/PNG.",
      optionalServiceQuestion: "İsteğe bağlı soru — ekibimize yardımcı oluyorsa cevaplayın.",
      requestCreated: "Talep Oluşturuldu",
      underReview: "İnceleniyor",
      inProgress: "Devam Ediyor",
      photo: "Fotoğraf",
      hiThere: "Merhaba,",
      serviceRequestDeclinedMessage: "Hizmet talebinizi inceledik, ancak şu anda onaylanamadı.",
      whatWeNeed: "İhtiyacımız olan:",
      declineReasonGeneric: "Bu, eksik detaylar, hizmet uygunluğu veya diğer onay koşulları nedeniyle olabilir.",
      declineInstruction: "Lütfen bilgilerinizi gözden geçirin ve bu güncellemeler yapıldıktan sonra yeni bir istek gönderin.",
      answered: "Cevaplandı",
      pendingAnswer: "Yanıt bekleniyor",
      requiredField: "Bu yanıt gereklidir",
      questionsAnswered: "soru cevaplandı",
      readyToSubmitChanges: "Güncellemeleri göndermeye hazır",
      questionsUpToDate: "Tüm yanıtlar güncel",
      updateAnyAnswerToResubmit: "Yeni bilgi göndermeniz gerekiyorsa yukarıdaki herhangi bir yanıtı güncelleyin.",
      answerTypeText: "Metin",
      answerTypeYesNo: "Evet / Hayır",
      answerTypeDropdown: "Açılır Menü",
      answerTypeMultiSelect: "Çoklu Seçim",
      answerTypeFileUpload: "Fotoğraf Yükleme",
      pendingApproval: "Onay Bekliyor",
      awaitingMoreInformation: "Daha Fazla Bilgi Bekleniyor",
      closed: "Kapandı / Kapatıldı",
      noServiceRequestsFound: "Hizmet talebi bulunamadı",
      fleetAllocation: "Filo Tahsisi",
      fleetAllocations: "Filo Tahsisleri",
      userAgreement: "Kullanıcı Sözleşmesi",
      organisationCode: "Organizasyon Kodu",
      serviceReference: "Hizmet Referansı",
      completionDate: "Tamamlanma Tarihi",
      addTask: "Görev Ekle",
      noTaskFound: "Görev bulunamadı. Görevleri manuel olarak ekleyebilirsiniz.",
      taskName: "Görev Adı",
      features: "Özellikler",
      interiorFeatures: "İç Özellikler",
      exteriorFeatures: "Dış Özellikler",
      safetyAndTechnicalFeatures: "Güvenlik ve Teknik Özellikler",
      otherFeatures: "Diğer Özellikler",
      privateHiresNo: "Özel Kiralama No",
      pcoPrivateHiresHireDLNo: "PCO/Özel Kiralama Ehliyet No",
      gender: "Cinsiyet",
      secondaryEmailAddress: "İkincil E-posta Adresi",
      secondaryPhoneNumber: "İkincil Telefon Numarası",
      driverAge: "Sürücü Yaşı",
      licenceDuration: "Ehliyet Süresi",
      penaltyPoints: "Ceza Puanı",
      insuranceClaimsHistory: "Sigorta Hasar Geçmişi",
      pcoExpiryDate: "PCO son kullanma tarihi",
      state: "İl / Eyalet",
      selectBookingType: "Rezervasyon Türünü Seçin",
      selectBookingTypeDialog: "Rezervasyona devam etmek için lütfen aşağıdaki rezervasyon türlerinden birini seçin",
      regularBooking: "Normal Rezervasyon",
      contactlessBooking: "Temassız Rezervasyon",
      reviewBookingDetails: "Rezervasyon detaylarını incele"
    },
    misc: {
      edit: "Düzenle",
      logOut: "Çıkış Yap",
      licence: "Ehliyet",
      cancel: "İptal",
      save: "Kaydet",
      status: {
        PENDING: "Beklemede",
        APPROVED: "Onaylandı",
        DECLINED: "Reddedildi",
        IN_REVIEW: "İnceleniyor",
      },
      delete: "Sil",
      create: "Oluştur",
      signIn: "Giriş Yap",
      select: "Seç",
      back: "Geri",
      error: "Hata",
      yes: "Evet",
      no: "Hayır",
      payConfirm: "Öde ve Onayla",
      clickToAdd: "Eklemek için tıklayın",
      close: "Kapat",
      download: "İndir",
      selectCaps: "SEÇ",
      forgotPassword: "Şifrenizi mi unuttunuz?",
      pleaseNote: "Lütfen Dikkat Edin",
      front: "Ön",
      columnKey: {
        "#": "#",
        Particulars: "Ayrıntılar",
        Quantity: "Miktar",
        "Unit Price": "Birim Fiyat",
        Duration: "Süre",
        "Discounted Price": "İndirimli Fiyat",
        "VAT/TAX": "KDV/VERGİ",
        Amount: "Tutar",
      },
      columnLabelToKeyMap: {
        ITEM: "ÖGE",
        DESCRIPTION: "AÇIKLAMA",
        QUANTITY: "MİKTAR",
        "UNIT PRICE": "BİRİM FİYAT",
        DURATION: "SÜRE",
        "DISCOUNTED PRICE": "İNDİRİMLİ FİYAT",
        "VAT/TAX": "KDV/VERGİ",
        PRICE: "FİYAT",
      },
      paymentColumnsKey: {
        Date: "Tarih",
        Amount: "Tutar",
        "Mode Of Payments": "Ödeme Yöntemi",
        Status: "Durum",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Fatura Referans Numarası",
        "Vehicle Registration Numbers": "Araç Tescil Numarası(ları)"
      },
      buttonKey: {
        Rentals: "Kiralama",
        Subscriptions: "Abonelikler",
        "Test Drive": "Test Sürüşü",
        "Contract Hire": "Sözleşmeli Kiralama",
      },
      subLabelKey: {
        "Book vehicle for hours and days": "Aracı saatlik/günlük kiralayın",
        "Subscribe vehicle for weekly/monthly":
          "Araca haftalık/aylık abone olun",
        "Test Drive our Premium Vehicles": "Premium araçlarımızı test edin",
        "Contract Hire vehicle for weekly/monthly":
          "Haftalık/aylık sözleşmeli araç kiralama",
      },
      buttonTextKey: {
        "Subscribe Now": "Hemen Abone Ol",
        "Book Now": "Hemen Rezerve Et",
        "Contract Now": "Şimdi Sözleşme Yap",
      },
      featuresKey: {
        "Flexible Leasing Options": "Esnek Kiralama Seçenekleri",
        "Choose the duration of your subscription as you go":
          "Abonelik sürenizi istediğiniz gibi seçin",
        "Change car anytime*": "Aracı istediğiniz zaman değiştirin*",
        "Home delivery option": "Eve teslim seçeneği",
        "100% digital": "%100 dijital",
        "MOT and taxes": "Muayene ve vergiler",
        "Without down payment": "Peşinat olmadan",
        "Vehicle Servicing": "Araç Servisi",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Tutar",
        "Adjusted To Invoice": "Faturaya Uygulandı",
        "Adjusted At": "Uygulanma Tarihi",
      },
      categoriesKey: {
        Knowledge: "Bilgi",
        Behavior: "Davranış",
        Punctuality: "Dakiklik",
      },
    },
    snackBar: {
      customerInfoSaved: "Müşteri bilgileri kaydedildi",
      documentDeleted: "Belge başarıyla silindi",
      documentDeleteFailed: "Belge silinemedi",
      documentDeleteError: "Belgeyi silme hatası",
      documentMarkedForDeletion:
        "Silinme için işaretlenmiş belge. Kaydettiğinizde değişimler uygulanacaktır.",
      profileImageUploaded: "Profil resmi başarıyla yüklendi",
      uploadImageFormatError:
        "Lütfen yalnızca .jpeg/.jpg/.png görüntü biçimi yükleyin!",
      selectDocumentType: "Lütfen Belge Türünü Seçin",
      selectExpiryDate: "Lütfen belge son kullanma tarihini seçin",
      fileSizeExceeded50mb: "Dosya boyutu 50 MB sınırını aştı",
      fileSizeExceeded5mb: "Dosya boyutu 5 MB sınırını aştı",
      uploadSuccess: "Belge başarıyla yüklendi",
      invalidUploadFormat:
        "Lütfen yalnızca PDF, PNG, JPG veya JPEG dosyalarını yükleyin",
      selectExpiryDateUpload:
        "Lütfen yüklemeden önce bir son kullanma tarihi seçin",
      ImageUploaded: "Resim başarıyla yüklendi",
      invalidFileType:
        "Geçersiz Dosya Türü. İzin verilen türler: jpeg veya png",
      costCenterInfoMissing: "Maliyet Merkezi bilgisi eksik!",
      selectedDriverAlreadyAdded: "Seçilen sürücü zaten eklendi.",
      driverSavedSuccessfully: "Sürücü başarıyla kaydedildi.",
      additionalDriverCannotBeMore:
        "Ek sürücüler, eklenti miktarından fazla olamaz",
      verificationStatusInReview: "Doğrulama durumu incelemede",
      verificationStatusPending: "Doğrulama durumu beklemede",
      quoteCreated: "Teklif oluşturuldu",
      bookingCreated: "Rezervasyon oluşturuldu",
      pickUpLocationEmpty: "Teslim alma lokasyonu boş",
      slotSelectionRequiredForNonNegotiable: "Zaman dilimi seçimi gereklidir.",
      protectionPlanMandatoryForPCOBooking:
        "Bu rezervasyon için koruma planı zorunludur",
      paymentAlreadyDone: "Ödeme zaten yapıldı",
      fileBeingGenerated:
        "Dosya oluşturuluyor, lütfen daha sonra tekrar deneyin",
      provideDeliveryAddress: "Lütfen teslimat adresini girin!",
      noValidCreditReadingFound:
        "Bu şirket için geçerli kredi puanı bulunamadı.",
      noValidCreditScoreFound:
        "Geçerli bir kredi skoru bulunamadı. Kredi kontrol limiti aşılmış olabilir.",
      atleastOneLicenceImage: "En az bir ehliyet görseli yükleyin",
      licenceImageUploaded: "Ehliyet görseli başarıyla yüklendi",
      maximumTwoImageLicence: "Ehliyet için en fazla iki görsel yüklenebilir!",
      imageUploadInProgress: "Lütfen bekleyin, görsel yükleniyor!",
      errorFetchingSignedUrl: "İmzalı URL alınırken hata oluştu",
      paymentFailed: "Ödeme başarısız oldu, lütfen tekrar deneyin",
      paymentFailedReasonCardDetails:
        "Ödemeniz başarısız oldu! Lütfen kart bilgilerinizi kontrol edin veya daha sonra tekrar deneyin.",
      maximumTwoImage: "En fazla iki görsel yüklenebilir:",

      cancelledSuccessfully: "Başarıyla iptal edildi",
      selectReasonForCancel: "Lütfen iptal sebebini girin",
      streetZipcodeRequired: "Sokak / Posta kodu gerekli",
      feedbackSaved: "Teşekkürler! Geri bildiriminiz kaydedildi",
      driverAlreadyAdded: "Sürücü zaten eklendi!",
      driverRemoved: "Sürücü başarıyla kaldırıldı",
      businessCustomerDriverDeleted: "Ticari müşteri sürücüsü silindi.",
      errorInSavingData: "Veri kaydedilirken hata oluştu",
      damageInformationSaved: "Hasar bilgisi başarıyla kaydedildi.",
      errorSavingData: "Veri kaydedilirken hata oluştu",
      problemTelematicsData: "Telematik veriler yüklenirken sorun oluştu",
      verificationRequestSent: "Doğrulama talebi başarıyla gönderildi.",
      vehicleStateUpdated: "Araç durumu güncellendi",
      driverAdded: "Sürücü eklendi.",
      businessCustomerCreated: "Kurumsal müşteri oluşturuldu.",
      uploadOnlyImageFiles: "Lütfen sadece resim dosyaları yükleyin (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "Resim boyutu 5MB'yi geçmemelidir",
      uploadFailed: "Yükleme başarısız oldu",
      imagesUploadedSuccessfully: "resim(ler) başarıyla yüklendi!",
      failedToUploadImages: "Resimler yüklenemedi. Lütfen tekrar deneyin.",
      pleaseSelectVehicle: "Lütfen bir araç seçin",
      pleaseFillInAllIssueDetails: "Lütfen tüm sorun detaylarını doldurun",
      serviceRequestCreatedSuccessfully: "Servis talebi başarıyla oluşturuldu! Referans:",
      errorCreatingServiceRequest: "Servis talebi oluşturulurken hata",
      pleaseEnterNote: "Lütfen bir not girin",
      noteAddedSuccessfully: "Not başarıyla eklendi",
      errorAddingNote: "Not eklenirken hata",
      pleaseAnswerAllRemainingQuestions: "Lütfen kalan tüm {{count}} soruyu{{plural}} cevaplayın",
      answersSubmittedSuccessfully: "Cevaplar başarıyla gönderildi! Talebiniz şimdi inceleme altında.",
      errorSubmittingAnswers: "Cevaplar gönderilirken hata",
      serviceRequestNotFound: "Servis talebi bulunamadı",
      errorLoadingServiceRequests: "Hizmet talepleri yüklenirken hata",
      oneVehicleForContactless: "Temassız rezervasyon için yalnızca bir araç seçilebilir",
      oneVehicleForNonContactless: "Temassız olmayan rezervasyon için yalnızca uygun araç seçilebilir",
      contactlessVehicleCannotBeSelected: "Temassız araç normal rezervasyonlar için seçilemez",
      bookingDetailsCreated: "Rezervasyon detayları oluşturuldu"
    },
    validation: {
      otpLengthMismatch: "OTP'nin uzunluğu 6 karakter olmalıdır.",
      invalidOtp: "Geçersiz OTP",
      required: "{{field}} gereklidir",
      billingEmailInvalid: "Lütfen geçerli bir fatura e-posta adresi girin.",
      billingEmailRequired: "Faturalandırma e -postası gereklidir.",
      addressRequired: "Adres gerekli",
      phoneNumberRequired: "Telefon numarası gereklidir.",
      businessNameRequired: "İşletme adı gereklidir.",
      registrationNumberRequired: "Kayıt numarası gereklidir",
      vatRequired: "KDV/Vergi kayıt numarası gereklidir",
      accountNumberRequired: "Hesap numarası gereklidir",
      registeredAddressRequired: "Kayıtlı adres gerekli",
      registeredAddressCountryRequired: "Ülke gereklidir",
      registeredAddressStateRequired: "Eyalet gereklidir",
      registeredAddressCityRequired: "Şehir gereklidir",
      registeredAddressStreetRequired: "Sokak gereklidir",
      tradingAddressRequired: "Ticaret adresi gerekli",
      tradingAddressCountryRequired: "Ülke gereklidir",
      tradingAddressStateRequired: "Eyalet gereklidir",
      tradingAddressCityRequired: "Şehir gereklidir",
      tradingAddressStreetRequired: "Sokak gereklidir",
      contactEmailRequired: "İletişim e -postası gereklidir.",
      firstNameRequired: "Adı gereklidir.",
      middleNameRequired: "İkinci ad gereklidir.",
      lastNameRequired: "Soyadı gereklidir.",
      locationRequired: "Konum gerekli",
      streetZipcodeRequired: "Sokak/Posta Kodu gereklidir",
      emailIsRequired: "E-posta gereklidir",
      termsConditionsAccepted: "Şartlar ve koşullar kabul edilmelidir",
      drivingLicenceNumberRequired: "Sürücü belgesi numarası gerekli",
      nationalInsuranceNumberRequired: "Ulusal sigorta numarası gerekli",
      enterValidPhoneNumber: "Lütfen geçerli bir telefon numarası girin.",
      enterValidEmailAddress: "Lütfen geçerli bir e-posta adresi girin",
      authorityRequired: "Yetkili kurum zorunludur",
      licenceNumberRequired: "Ehliyet numarası zorunludur",
      licenceExpiryDateRequired: "Ehliyet son kullanma tarihi zorunludur",
      expiryDateRequired: "Son kullanma tarihi gerekli",
      numberIsRequired: "Numara gerekli",

      passwordLengthValidaion: "Parola uzunluğu en az 8 karakter olmalıdır",
      passwordContainUppercase: "Parola en az bir büyük harf içermelidir",
      passwordContainLowercase: "Parola en az bir küçük harf içermelidir",
      passwordContainOneNumber: "Parola en az bir rakam içermelidir",
      passwordContainSpecialCharacter:
        "Parola en az bir özel karakter içermelidir",
      passwordMustMatch: "Parolalar eşleşmelidir",
      atleastOneUppercase: "En az bir büyük harf",
      atleastOneLowercase: "En az bir küçük harf",
      atleastOneNumericalChar: "En az bir sayısal karakter",
      atleastOneSpecialChar: "En az bir özel karakter",
      pleaseEnterAValidEmail: "Lütfen geçerli bir e-posta adresi girin",
      driverNotFound: "Sürücü bulunamadı",
      batteryStatusNumber: "Akü/Şarj durumu sayısal olmalıdır",
      batteryStatusCantNegative: "Pil durumu negatif olamaz",
      batteryStatusCantMoreHundred: "Pil durumu %100'den fazla olamaz",
      batteryStatusRequired: "Pil durumu gereklidir",
      odometerReadingMustNumber: "Kilometre okuması bir sayı olmalıdır",
      odometerReadingRequired: "Kilometre okuması gereklidir",
      odometerMustEqualOrHigherLast:
        "Kilometre okuması son bildirilen değerden düşük olamaz",
      titleIsRequired: "Başlık gereklidir.",
      damageKindIsRequired: "Hasar türü gereklidir.",
      descriptionIsRequired: "Açıklama gereklidir.",
      damageImageIsRequired: "Hasar görseli gereklidir.",
      professionIsRequired: "Meslek gereklidir",
      passportNineCharacters: "Pasaport numarası 9 karakter olmalıdır",
      passportIsRequired: "Pasaport gereklidir",
      organisationCodeRequired: "Organizasyon Kodu Gereklidir",
      userNotFound: "Kullanıcı bulunamadı",
      invalidPassword: "Geçersiz parola",
      passwordLengthError: "Şifre uzunluğu en az 8 karakter olmalıdır",
      customerPCONumberRequired: "PCO / özel kiralama ehliyet numarası gereklidir",
      genderRequired: "Cinsiyet gereklidir",
      nationalityRequired: "Uyruk zorunludur",
    },
  },
};